import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import createGrading from "./create_grading";

const getGrading = async (branchId) => {
  const db = getFirestore();
  const gradingCollection = collection(db, "grading");
  const q = query(gradingCollection, where("branchId", "==", branchId));

  try {
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const gradingData = querySnapshot.docs[0].data();
      return gradingData;
    } else {
      // No grading data found, create default grading
      console.log("No grading data found, creating default grading for branch:", branchId);
      const defaultGrading = await createGrading(branchId);
      return defaultGrading;
    }
  } catch (error) {
    console.error("Error fetching grading:", error);
    throw error;
  }
};

export default getGrading;
